// extracted by mini-css-extract-plugin
export var messageSideLeft = "_od-1";
export var messageSideRight = "_od-2";
export var subscribeToBackInStockBubbleContainer = "_od-0";